import { createActions } from '../utils/actions';

const { actions: profiles } = createActions('profiles')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('connectListings')
  .addAsync('copyProfile')
  .addAsync('deleteProfile')
  .addAsync('disconnectListing')
  .add('edit')
  .addAsync('getAiOperations')
  .addAsync('getFilters')
  .addAsync('getListings')
  .addAsync('getProfiles')
  .addAsync('getTemplates')
  .addAsync('saveProfile')
  .add('search')
  .add('setData')
  .add('setModal')
  .add('setPage')
  .add('setSection')
  .add('setType')
  .addAsync('showConnectModal')
  .addAsync('toggleTemplateMode')
  .add('updateTemplateAttributes');

export default profiles;
